import styled from 'styled-components';

const RowBreak = styled.div`
flex-basis: 100%;
height: 0;
`;

export default RowBreak;



// WEBPACK FOOTER //
// ./src/components/formElements/RowBreak.tsx